export default __webpack_public_path__ + "d4af6fa.png";